module.exports = "<div class=modal-header> <button type=button class=\"btn btn-default\" ng-click=cancel() style=float:right>Close</button> <h3 class=modal-title><i class=\"glyphicon glyphicon-tasks\"></i>&nbsp;&nbsp;{{bodyData.type}} Body</h3> </div> <div class=modal-body style=width:100%;display:inline-block> <div class=route-detail-container> <div class=\"data-group left-indent\"> <div class=data-value style=padding-left:0> <div class=\"hljsFormat hljsFormatFull\" hljs source=bodyData.content></div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/views/transactionsBodyModal.html
// module id = 161
// module chunks = 0